import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  shiftsDisabled: {
    id: 'shifts.shiftsDisabled',
    defaultMessage: 'Työajanseuranta ei ole käytössä yrityksellänne',
  },
  errorPageHeading: {
    id: 'shifts.errorPageHeading',
    defaultMessage: 'Vuorot',
  },
  noShiftStatus: {
    id: 'shifts.noShift.status',
    defaultMessage: 'Tila: Ei aktiivinen',
  },
  startWork: {
    id: 'shifts.startWork',
    defaultMessage: 'Aloita työvuoro',
  },
  startStandby: {
    id: 'shifts.startStandby',
    defaultMessage: 'Aloita varallaolovuoro',
  },
  standbyStatus: {
    id: 'shifts.standby.status',
    defaultMessage: 'Varalla',
  },
  standbyStartWork: {
    id: 'shifts.standby.startWork',
    defaultMessage: 'Aloita työ',
  },
  endStandby: {
    id: 'shifts.standby.end',
    defaultMessage: 'Lopeta varallaolovuoro',
  },
  workStatusStandby: {
    id: 'shifts.work.statusStandby',
    defaultMessage: 'Töissä (varalla)',
  },
  workStatus: {
    id: 'shifts.work.status',
    defaultMessage: 'Töissä',
  },
  startBreak: {
    id: 'shifts.work.startBreak',
    defaultMessage: 'Aloita tauko',
  },
  startWait: {
    id: 'shifts.work.startWait',
    defaultMessage: 'Aloita odotus',
  },
  endWork: {
    id: 'shifts.work.end',
    defaultMessage: 'Lopeta työvuoro',
  },
  endWorkStandby: {
    id: 'shifts.work.endStandby',
    defaultMessage: 'Lopeta työ',
  },
  breakStatus: {
    id: 'shifts.break.status',
    defaultMessage: 'Tauko',
  },
  endBreak: {
    id: 'shifts.break.end',
    defaultMessage: 'Lopeta tauko',
  },
  waitStatus: {
    id: 'shifts.wait.status',
    defaultMessage: 'Odotus',
  },
  endWait: {
    id: 'shifts.wait.end',
    defaultMessage: 'Lopeta odotus',
  },
  eventTime: {
    id: 'shifts.addEvent.time',
    defaultMessage: 'Aika',
  },
  eventComment: {
    id: 'shifts.addEvent.comment',
    defaultMessage: 'Lisätiedot',
  },
  eventEstimatedEnd: {
    id: 'shifts.addEvent.estimatedEnd',
    defaultMessage: 'Suunniteltu päättymisaika:',
  },
  tableEventColumn: {
    id: 'shifts.table.event',
    defaultMessage: 'Tapahtuma',
  },
  tableDateColumn: {
    id: 'shifts.table.date',
    defaultMessage: 'Pvm',
  },
  tableTimeColumn: {
    id: 'shifts.table.time',
    defaultMessage: 'Klo',
  },
  tableInfoColumn: {
    id: 'shifts.table.info',
    defaultMessage: 'Lisätiedot',
  },
  eventTypeWorkStart: {
    id: 'shifts.eventType.workStart',
    defaultMessage: 'Työ aloitettu',
  },
  eventTypeWorkEnd: {
    id: 'shifts.eventType.workEnd',
    defaultMessage: 'Työ lopetettu',
  },
  eventTypeBreakStart: {
    id: 'shifts.eventType.breakStart',
    defaultMessage: 'Tauko aloitettu',
  },
  eventTypeBreakEnd: {
    id: 'shifts.eventType.breakEnd',
    defaultMessage: 'Tauko lopetettu',
  },
  eventTypeStandbyStart: {
    id: 'shifts.eventType.standbyStart',
    defaultMessage: 'Varallaolo aloitettu',
  },
  eventTypeStandbyEnd: {
    id: 'shifts.eventType.standbyEnd',
    defaultMessage: 'Varallaolo lopetettu',
  },
  eventTypeWaitStart: {
    id: 'shifts.eventType.waitStart',
    defaultMessage: 'Odotus aloitettu',
  },
  eventTypeWaitEnd: {
    id: 'shifts.eventType.waitEnd',
    defaultMessage: 'Odotus lopetettu',
  },
  eventTypeStandbyWorkStart: {
    id: 'shifts.eventType.standbyWorkStart',
    defaultMessage: 'Työ (varalla) aloitettu',
  },
  eventTypeStandbyWorkEnd: {
    id: 'shifts.eventType.standbyWorkEnd',
    defaultMessage: 'Työ (varalla) lopetettu',
  },
})
